import { useMemo } from 'react';

import type { ActionButton } from '@scaleaq/scaleui';

import { useTranslation } from 'react-i18next';

import { ModalGridContent } from '@/styles.ts';
import { WidgetConfigModalProps } from '@/types.ts';

import { WidgetConfigModalFooter } from './widgetConfigSiteTabbedShellContent/WidgetConfigModalFooter.tsx';
import { WidgetSiteTabbedConfig } from './widgetConfigSiteTabbedShellContent/WidgetSiteTabbedConfig.tsx';
import type { WidgetSiteTabbedConfigProps } from './widgetConfigSiteTabbedShellContent/widgetSiteTabbedConfig/siteTabbedInventoryLayout/siteTabbedInventoryLayout.types.ts';
import { useWidgetSiteTabbedShellCtx } from './widgetSiteTabbedShellProvider/WidgetSiteTabbedShellContext.ts';

export type WidgetConfigSiteTabbedShellContentProps = WidgetSiteTabbedConfigProps &
  Pick<WidgetConfigModalProps, 'onClose' | 'onGoBack'> & {
    /** Shows a Save button that targets the active site tab's registered save handler. */
    showSave?: boolean;
  };

/** Site tabs + footer; must render inside {@link WidgetSiteTabbedShellProvider}. */
export const WidgetConfigSiteTabbedShellContent = ({
  onClose,
  onGoBack,
  showSave,
  ...tabbedConfigProps
}: WidgetConfigSiteTabbedShellContentProps) => {
  const { t } = useTranslation();
  const { saveActivePanel } = useWidgetSiteTabbedShellCtx();

  const saveButton = useMemo((): ActionButton | undefined => {
    if (!showSave) return undefined;

    return {
      label: t('save'),
      onClick: () => saveActivePanel(),
    };
  }, [saveActivePanel, showSave, t]);

  return (
    <>
      <ModalGridContent>
        <WidgetSiteTabbedConfig {...tabbedConfigProps} />
      </ModalGridContent>
      <WidgetConfigModalFooter
        leadingActionButtons={saveButton ? [saveButton] : undefined}
        onClose={onClose}
        onGoBack={onGoBack}
      />
    </>
  );
};
